import { render, staticRenderFns } from "./Son_Date.vue?vue&type=template&id=140e1c5f&scoped=true&"
import script from "./Son_Date.vue?vue&type=script&lang=js&"
export * from "./Son_Date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e1c5f",
  null
  
)

export default component.exports